<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="loading" persistent max-width="200">
          <v-card>
            <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row justify-center>
                  <v-flex xs12 sm6 md4 lg3>
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200">
          <material-card
            :title="$t('views.portal.welcome_kit')"
            :color="$vuetify.theme.themes.light.primary"
            icon="mail"
          >
            <v-card-text>
              <v-form v-model="valid">
                <v-container fluid>
                  <v-row>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      v-if="welcomeKit !== null && welcomeKit !== undefined"
                    >
                      <quill-editor
                        ref="quillEditor"
                        v-model="welcomeKit.Html"
                        :options="editorOption"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="images !== null && images !== undefined">
                    <template v-for="index in totalImages">
                      <v-col xs="12" sm="6" md="6" lg="6" :key="index">
                        <single-file-upload2
                          :id="'welcomeKitImage' + index"
                          @emit-upload-start="saving = true"
                          @emit-upload-end="saving = false"
                          :label="$t('views.welcomekit.image_{0}', [index])"
                          :tags="[selectedPlan.UniqueIdentifier]"
                          :categories="['welcomeKit']"
                          :currentFolder="selectedPlan.Name"
                          :fileUploadUrl="
                            settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                          "
                          @emit-files="
                            bindFile($event, index - 1);
                            saving = false;
                          "
                          @emit-upload-error="
                            error = $event;
                            saving = false;
                          "
                          :filesIds="
                            images[index - 1] !== null &&
                            images[index - 1] !== undefined
                              ? [images[index - 1].PhysicalFileId]
                              : []
                          "
                          :getFilesUrl="
                            settings.DOCUMENTSERVICEURL + 'api/Files'
                          "
                        />
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="dialogs.cancel = true" :disabled="saving">
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn
                :disabled="!valid"
                :loading="saving"
                color="primary"
                @click="save"
              >
                {{ $t("globals.save") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog v-model="dialogs.cancel" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">
              {{ $t("globals.cancel") }}
            </v-card-title>
            <v-card-text>
              {{ $t("views.welcomekit.cancel_warning") }}
            </v-card-text>
            <v-card-actions>
              <v-btn color text @click="dialogs.cancel = false">
                {{ $t("globals.keep_working") }}
              </v-btn>
              <v-btn color="primary" @click="cancel">
                {{ $t("globals.cancel_anyway") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card
      :title="$t('views.portal.welcome_kits')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="mail"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="welcome_kits"
        identifier="welcomeKits"
        @error="error = $event"
        @itemsChanged="welcomeKits = $event"
      ></pbas-data-table>

      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { ODataProvider } from "pbas-vue-components";
import { mapGetters, mapActions } from "vuex";
import { locker } from "../mixins/locker";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";
import TransTexteditor from "../components/TransTexteditor";
import ErrorHandler from "../components/ErrorHandler";
import SingleFileUpload2 from "../components/SingleFileUpload2.vue";
import WelcomeKitHeaders from "../headers/WelcomeKits";
export default {
  components: {
    TransTexteditor,
    ErrorHandler,
    SingleFileUpload2,
  },
  mixins: [locker, planSetter, portalPermission],
  data() {
    return {
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.loadWelcomeKit(item),
        },
      ],
      headers: WelcomeKitHeaders,
      provider: undefined,
      totalImages: 9,
      dialogs: {
        cancel: false,
        edit: false,
      },
      saving: false,
      valid: false,
      images: null,
      welcomeKit: null,
      error: null,
      editorOption: {
        modules: {
          // toolbar: {
          //   handlers: {
          //     // handlers object will be merged with default handlers object
          //     link: function(value) {
          //       console.log("link: ", value);
          //       if (value) {
          //         var href = prompt("Enter the URL");
          //         this.quill.format("link", href);
          //       } else {
          //         this.quill.format("link", false);
          //       }
          //     },
          //   },
          // },
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"], // remove formatting button
            ["link", "image", "video"],
            ["theme-btn"],
          ],
        },
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", [
      "getPlanWelcomeKit",
      "getWelcomeKitImages",
      "saveWelcomeKit",
    ]),
    async loadWelcomeKit(item) {
      try {
        this.loading = true;
        this.welcomeKit = JSON.parse(JSON.stringify(item));

        this.images = (await this.getWelcomeKitImages({
          welcomeKitId: this.welcomeKit.Id,
        })).value;

        this.dialogs.edit = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async save() {
      try {
        this.saving = true;
        let welcomeKit = JSON.parse(JSON.stringify(this.welcomeKit));
        welcomeKit.WelcomeKitImages = JSON.parse(JSON.stringify(this.images));
        await this.saveWelcomeKit(welcomeKit);
        this.welcomeKit = null;
        this.images = [];
        this.dialogs.edit = false;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      // this.$router.push({
      //   name: "portal",
      //   params: { planId: this.selectedPlan.Id },
      // });
      this.dialogs.cancel = false;
      this.dialogs.edit = false;
      this.welcomeKit = null;
      this.images = [];
    },
    bindFile(files, index) {
      console.log(index, this.images);
      if (this.images[index] !== null && this.images[index] !== undefined) {
        this.images[index].PhysicalFileId = files.file.Id;
      } else {
        this.images[index] = {
          WelcomeKitId: this.welcomeKit.Id,
          PhysicalFileId: files.file.Id,
          Order: index,
        };
      }
    },
    async loadPlanData() {
      let url = "cms/odata/Plans(" + this.selectedPlan.Id + ")/WelcomeKits";
      this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
    },
  },
};
</script>
